import { useId } from "react";

// Instagram's own colours on the glyph (founder, 2026-10-04). Each one gets
// its own gradient id, so two on one screen never borrow each other's.
// `tight` crops to the outline itself, so `size` is the logo's real edge
// (the Connect Instagram screens set it beside our app icon at the same size).
// `solid` paints it one colour instead (white on an Instagram-coloured button).
export default function InstagramGlyph({ size = 18, className, tight = false, solid }: { size?: number; className?: string; tight?: boolean; solid?: string }) {
  const id = `igGrad${useId().replace(/:/g, "")}`;
  const grad = solid ? null : id;
  return (
    <svg className={className} width={size} height={size} viewBox={tight ? "2 2 20 20" : "0 0 24 24"} aria-hidden="true">
      {grad && (
      <defs>
        <linearGradient id={grad} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#FFD600" />
          <stop offset="0.3" stopColor="#FF7A00" />
          <stop offset="0.55" stopColor="#FF0069" />
          <stop offset="0.8" stopColor="#D300C5" />
          <stop offset="1" stopColor="#7638FA" />
        </linearGradient>
      </defs>
      )}
      <rect x="3" y="3" width="18" height="18" rx="5.2" fill="none" stroke={solid || `url(#${grad})`} strokeWidth="2" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke={solid || `url(#${grad})`} strokeWidth="2" />
      <circle cx="17.3" cy="6.7" r="1.2" fill={solid || `url(#${grad})`} />
    </svg>
  );
}
